import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
// @ts-ignore types being interpreted from custom types, will need a version bump
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import messages from './messages';

interface ClearConversationModalProps {
    onClose: () => void;
    onClearButtonClick: () => void;
}

export const ClearConversationModal = ({ onClose, onClearButtonClick }: ClearConversationModalProps) => {
    const { formatMessage } = useIntl();

    return (
        <Modal onClose={onClose}>
            <ModalHeader>
                <ModalTitle appearance="warning">{formatMessage(messages.modalTitle)}</ModalTitle>
            </ModalHeader>
            <ModalBody>{formatMessage(messages.modalBody)}</ModalBody>
            <ModalFooter>
                <Button appearance="subtle" onClick={onClose}>
                    {formatMessage(messages.modalCancelButton)}
                </Button>
                <Button appearance="primary" onClick={onClearButtonClick}>
                    {formatMessage(messages.modalClearButton)}
                </Button>
            </ModalFooter>
        </Modal>
    );
};
